import script from "./UserDetails.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserDetails.vue?vue&type=script&lang=ts&setup=true"

import "./UserDetails.vue?vue&type=style&index=0&id=6067a371&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6067a371"]])

export default __exports__